import { ActionCreatorWithOptionalPayload, createAction } from '@reduxjs/toolkit';
import { UserConstants } from './constants';
import { redirectToLogout, updateSession } from './sideEffects';

export const changeLanguage = createAction(UserConstants.USER_CHANGE_LANGUAGE, (languageId: number) => ({
    payload: { languageId },
}));

export const setIsAuthorized = createAction(UserConstants.USER_SET_IS_AUTORIZED, (isAuthorized: boolean) => ({
    payload: { isAuthorized },
}));

// Side Effect Actions
export const loginUser = createAction(UserConstants.USER_LOGIN, (userId: string) => {
    updateSession(userId);
    return { payload: { userId } };
});

export const deleteUser = (): ActionCreatorWithOptionalPayload<UserConstants.USER_DELETE> => {
    redirectToLogout();
    return createAction(UserConstants.USER_DELETE);
};

export const logoutUser = (): ActionCreatorWithOptionalPayload<UserConstants.USER_LOGOUT> => {
    redirectToLogout();
    return createAction(UserConstants.USER_LOGOUT);
};
